export const ar = {
  global: {
    my: 'لي',
    policies: 'سياسات',
    quotes: 'يقتبس',
    claims: 'المطالبات',
    speakWithAnAdvisor: 'تحدث مع مستشار',
    profile: 'الشخصي',
    settings: 'إعدادات',
    logout: 'تسجيل خروج',
    car: 'سيارة',
    home: 'منزل',
    life: 'الحياة',
    health: 'الصحة',
    yacht: 'يخت',
    travel: 'السفر',
    bike: 'دراجة هوائية',
    insurance: 'تأمين',
    hello: 'مرحبا',
    thankYouForRequest:
      'شكرا لطلبك. المتسوق الشخصي الخاص بك سوف يتصل بك قريبا!',
    save: 'حفظ',
    reset: 'إعادة تعيين',
    thankYou: 'شكرا جزيلا',
    email: 'البريد الإلكتروني',
    isRequired: 'مطلوب',
    mustValidEmail: 'يجب أن يكون بريدًا إلكترونيًا صالحًا',

    //yacht modal
    personalDetails: 'تفاصيل شخصية',
    firstName: 'الاسم الاول',
    lastName: 'الكنية',
    phoneNumber: 'رقم الهاتف',
    must3Alphabets: 'يجب أن يكون الحد الأدنى 3 أحرف أبجدية',
    max20Alphabets: 'يسمح بحد أقصى 20 حرفًا أبجديًا',
    mustValidPhoneNumber: 'يجب أن يكون رقم هاتف إماراتي صالحًا',

    // footer
    compare: 'قارن',
    companies: 'الشركات',
    aboutUs: 'معلومات عنا',
    guides: 'خطوط إرشاد',
    bussiness: 'الأعمال',
    RSA: 'RSA',
    AXA: 'AXA',
    OMAN: 'عمان',
    noorTakaful: 'نور تكافل',
    NGI: 'NGI',
    coverage: 'تغطية',
    comparison: 'مقارنة',
    discounts: 'الخصومات',
    ourStory: 'قصتنا',
    leadership: 'القيادة',
    contactUs: 'اتصل بنا',
    sitemap: 'خريطة الموقع',
    privacy: 'خصوصية',
    media: 'وسائل الإعلام',
    eBooks: 'كتب إلكترونية',
    blogs: 'المدونات',
    CEOBlog: 'مدونة الرئيس التنفيذي',
    knowYourInsurance: 'تعرف على تأمينك',
    askTheExpert: 'اسأل الخبير',
    FAQ: 'التعليمات',

    footerTagLine1:
      '© AFIA Insurance Brokerage Services LLC ، رقم التسجيل 85 في هيئة التأمين الإماراتية.',
    footerTagLine2:
      'حامل HIIP من هيئة الصحة بدبي رقم معرف الوسيط BRK-00003 | عضو مسجل في جمعية الإمارات للتأمين',
  },
  '/yacht-insurance': {
    // Section Banner //
    rating: 'تقييم',
    reviews: 'المراجعات',
    compareYacht: 'قارن تأمين اليخوت مع الفريد',
    floatAround: 'تطفو حول بحر الخليج براحة بال تامة',
    getQuotes: 'الحصول على اقتباسات في البريد الإلكتروني الخاص بك',
    weWillEmail:
      'سنرسل جدول مقارنة عبر البريد الإلكتروني ، ونساعدك في اختيار سياستك وإرسالها بالبريد الإلكتروني!',

    // Section Partners //
    ourYachtInsurance: 'شركاؤنا في تأمين اليخوت',
    oneSizeDoesNot:
      'حجم واحد لا يناسب الجميع. نحن نعمل مع شركات تأمين اليخوت الرائدة في الإمارات العربية المتحدة لتصميم السياسة المناسبة لك.',

    // SectionPleasureCraft //
    benefitsOfPleasure: 'فوائد تأمين الحرف اليدوية',

    hullnMachinery: 'هال والآلات',
    coversTheLoss:
      'يغطي الخسائر أو الأضرار التي لحقت باليخت بسبب الأخطار المؤمن عليها.',
    thirdPartyLiability: 'مسؤولية الطرف الثالث',
    coversYouAgainst:
      'يغطيك من الالتزامات التي قد تنشأ عن إصابة طرف ثالث أو تلف الممتلكات.',
    unInsuredBoater: 'قارب غير مؤمن عليه',
    coversYouAndGuests:
      'تحميك أنت وضيوفك في مركبتك الترفيهية من الإصابة الجسدية.',
    personalEffects: 'تأثيرات شخصية',
    isAnOptional:
      'هي تغطية اختيارية تغطي متعلقاتك الشخصية على قاربك من السرقة.',
    searchAndRescue: 'خدمات البحث والإنقاذ',
    coversExpenses: 'تغطي نفقات هذه الخدمة في حالة الحاجة إلى المساعدة.',
    racingRiskCoverage: 'تغطية مخاطر السباق',
    itIsAPolicyExtension:
      'هو امتداد للوثيقة يغطي الأضرار التي لحقت بقاربك من الحوادث التي تنشأ عن السباق.',

    // SectionEasySteps //
    HeadingSectionEasySteps:
      'احصل على تأمين اليخت الخاص بك من سوق التأمين في 3 خطوات سهلة',
    EasyStepText1: 'أكمل النموذج (يستغرق ثوانٍ)',
    EasyStepText2: 'نرسل لك أفضل العروض عبر البريد الإلكتروني',
    EasyStepText3: 'نرسل وثائق تأمين اليخت بالبريد الإلكتروني',

    // SectionBenefits //
    HeadingSectionBenefits: 'المزايا الاختيارية لتأمين اليخوت مع الفريد',
    yachtsAreBigInvestment:
      'اليخوت استثمار كبير. في InsuranceMarket.ae ، ندرك أنك ربما ترغب في التأكد من تغطية سفينتك بشكل صحيح مع إحدى شركات التأمين لدينا ، ونحن نعمل فقط مع الأفضل.',
    owningAndBuying:
      'يعد امتلاك وشراء اليخت الخاص بك أمرًا شخصيًا للغاية ، لذا يمكننا تخصيص بعض المزايا الاختيارية الإضافية لك إذا كنت ترغب في ذلك:',

    BenefitTitle1: 'مسؤولية المتزلجين على الماء',
    BenefitDetail1:
      'يعد التزلج على الماء متعة كبيرة ، ولكنه قد يكون خطيرًا. تعد تغطية المسؤولية القانونية للمتزلجين على الماء إضافة اختيارية لطيفة.',
    BenefitTitle2: 'تمديد نطاق المبحرة',
    BenefitDetail2:
      'يمكن للسفن ذات الطول المختلف أن تقطع مسافات مختلفة من مكان الرسو. ومع ذلك ، يمكننا تمديد هذا عند الطلب.',
    BenefitTitle3: 'مخاطر السباق',
    BenefitDetail3:
      'تحت غطاء شامل لليخوت ، يمكننا تمديد الوثيقة لتشمل سباقات القوارب والسباقات.',
    BenefitTitle4: 'حادث شخصي',
    BenefitDetail4:
      'قد يصبح الأمر خطيرًا في أعالي البحار ، لذلك يمكننا إضافة مزايا لك ولزوجك في حالة وقوع حادث خطير.',
    BenefitTitle5: 'تأثيرات شخصية',
    BenefitDetail5:
      'يمكننا ترتيب تغطية لممتلكاتك الشخصية والنقود على متن الطائرة في حالة اقتحام شخص ما.',
    BenefitTitle6: 'البحث و الإنقاذ',
    BenefitDetail6:
      'يمكن إضافة هذا الخيار حتى 25000 دولار أمريكي. فقط في حالة.',

    // SectionPromises //
    HeadingSectionPromises: "ALFRED'S وعود القلب",

    PromiseText1: 'أفضل قيمة ممكنة لأموالك',
    PromiseText2: 'فقط شركات التأمين الأكثر موثوقية',
    PromiseText3: 'تفاني عاطفي لخدمة المطالبات',
    PromiseText4: 'المتسوق الشخصي الخاص بك لمساعدتك في الاختيار',

    // SectionReviews //
    HeadingSectionReviews: 'هذا ما يقوله عملاؤنا',

    // SectionQuestions //
    HeadingSectionQuestions: 'بعض الأسئلة التي يتم طرحها بشكل متكرر',
    readAlfredsAdvice: 'اقرأ نصائح ألفريد ورؤيته حول بعض الأسئلة المطروحة.',

    Question1: 'هل تريد معرفة المزيد عن سياسات وأغلفة اليخوت؟',
    Answer1:
      'هناك عدد غير قليل من مزودي تأمين اليخوت المختلفين في الإمارات العربية المتحدة. لقد وجدنا أن علاقاتنا القوية مع بعض شركات التأمين تمكننا من الابتعاد عن سياسات "الحزمة" ، وإنشاء شيء أكثر ملاءمة لاحتياجاتك ...',
    learnMore: 'تعرف على المزيد حول تأمين اليخوت',

    // SectionGetInsurance //
    HeadingSectionGetInsurance: 'احصل على تأمين اليخت',
    quotesInYourEmailNow: 'اقتباسات في بريدك الإلكتروني الآن',
    thousandsOfCustomers:
      'يثق آلاف العملاء في InsuranceMarket.ae للحصول على أفضل صفقات التأمين',
    weWillEmailYourCustom:
      'سنرسل جدول المقارنة المخصص عبر البريد الإلكتروني لتوفير الوقت والمال',
  },
  '/typ-yacht-insurance': {
    // Section Banner //
    rating: 'تقييم',
    reviews: 'المراجعات',
    compareYacht: 'قارن تأمين اليخوت مع الفريد',
    floatAround: 'تطفو حول بحر الخليج براحة بال تامة',
    getQuotes: 'الحصول على اقتباسات في البريد الإلكتروني الخاص بك',
    weWillEmail:
      'سنرسل جدول مقارنة عبر البريد الإلكتروني ، ونساعدك في اختيار سياستك وإرسالها بالبريد الإلكتروني!',

    // Section Partners //
    ourYachtInsurance: 'شركاؤنا في تأمين اليخوت',
    oneSizeDoesNot:
      'حجم واحد لا يناسب الجميع. نحن نعمل مع شركات تأمين اليخوت الرائدة في الإمارات العربية المتحدة لتصميم السياسة المناسبة لك.',

    // SectionPleasureCraft //
    benefitsOfPleasure: 'فوائد تأمين الحرف اليدوية',

    hullnMachinery: 'هال والآلات',
    coversTheLoss:
      'يغطي الخسائر أو الأضرار التي لحقت باليخت بسبب الأخطار المؤمن عليها.',
    thirdPartyLiability: 'مسؤولية الطرف الثالث',
    coversYouAgainst:
      'يغطيك من الالتزامات التي قد تنشأ عن إصابة طرف ثالث أو تلف الممتلكات.',
    unInsuredBoater: 'قارب غير مؤمن عليه',
    coversYouAndGuests:
      'تحميك أنت وضيوفك في مركبتك الترفيهية من الإصابة الجسدية.',
    personalEffects: 'تأثيرات شخصية',
    isAnOptional:
      'هي تغطية اختيارية تغطي متعلقاتك الشخصية على قاربك من السرقة.',
    searchAndRescue: 'خدمات البحث والإنقاذ',
    coversExpenses: 'تغطي نفقات هذه الخدمة في حالة الحاجة إلى المساعدة.',
    racingRiskCoverage: 'تغطية مخاطر السباق',
    itIsAPolicyExtension:
      'هو امتداد للوثيقة يغطي الأضرار التي لحقت بقاربك من الحوادث التي تنشأ عن السباق.',

    // SectionEasySteps //
    HeadingSectionEasySteps:
      'احصل على تأمين اليخت الخاص بك من سوق التأمين في 3 خطوات سهلة',
    EasyStepText1: 'أكمل النموذج (يستغرق ثوانٍ)',
    EasyStepText2: 'نرسل لك أفضل العروض عبر البريد الإلكتروني',
    EasyStepText3: 'نرسل وثائق تأمين اليخت بالبريد الإلكتروني',

    // SectionBenefits //
    HeadingSectionBenefits: 'المزايا الاختيارية لتأمين اليخوت مع الفريد',
    yachtsAreBigInvestment:
      'اليخوت استثمار كبير. في InsuranceMarket.ae ، ندرك أنك ربما ترغب في التأكد من تغطية سفينتك بشكل صحيح مع إحدى شركات التأمين لدينا ، ونحن نعمل فقط مع الأفضل.',
    owningAndBuying:
      'يعد امتلاك وشراء اليخت الخاص بك أمرًا شخصيًا للغاية ، لذا يمكننا تخصيص بعض المزايا الاختيارية الإضافية لك إذا كنت ترغب في ذلك:',

    BenefitTitle1: 'مسؤولية المتزلجين على الماء',
    BenefitDetail1:
      'يعد التزلج على الماء متعة كبيرة ، ولكنه قد يكون خطيرًا. تعد تغطية المسؤولية القانونية للمتزلجين على الماء إضافة اختيارية لطيفة.',
    BenefitTitle2: 'تمديد نطاق المبحرة',
    BenefitDetail2:
      'يمكن للسفن ذات الطول المختلف أن تقطع مسافات مختلفة من مكان الرسو. ومع ذلك ، يمكننا تمديد هذا عند الطلب.',
    BenefitTitle3: 'مخاطر السباق',
    BenefitDetail3:
      'تحت غطاء شامل لليخوت ، يمكننا تمديد الوثيقة لتشمل سباقات القوارب والسباقات.',
    BenefitTitle4: 'حادث شخصي',
    BenefitDetail4:
      'قد يصبح الأمر خطيرًا في أعالي البحار ، لذلك يمكننا إضافة مزايا لك ولزوجك في حالة وقوع حادث خطير.',
    BenefitTitle5: 'تأثيرات شخصية',
    BenefitDetail5:
      'يمكننا ترتيب تغطية لممتلكاتك الشخصية والنقود على متن الطائرة في حالة اقتحام شخص ما.',
    BenefitTitle6: 'البحث و الإنقاذ',
    BenefitDetail6:
      'يمكن إضافة هذا الخيار حتى 25000 دولار أمريكي. فقط في حالة.',

    // SectionPromises //
    HeadingSectionPromises: "ALFRED'S وعود القلب",

    PromiseText1: 'أفضل قيمة ممكنة لأموالك',
    PromiseText2: 'فقط شركات التأمين الأكثر موثوقية',
    PromiseText3: 'تفاني عاطفي لخدمة المطالبات',
    PromiseText4: 'المتسوق الشخصي الخاص بك لمساعدتك في الاختيار',

    // SectionReviews //
    HeadingSectionReviews: 'هذا ما يقوله عملاؤنا',

    // SectionQuestions //
    HeadingSectionQuestions: 'بعض الأسئلة التي يتم طرحها بشكل متكرر',
    readAlfredsAdvice: 'اقرأ نصائح ألفريد ورؤيته حول بعض الأسئلة المطروحة.',

    Question1: 'هل تريد معرفة المزيد عن سياسات وأغلفة اليخوت؟',
    Answer1:
      'هناك عدد غير قليل من مزودي تأمين اليخوت المختلفين في الإمارات العربية المتحدة. لقد وجدنا أن علاقاتنا القوية مع بعض شركات التأمين تمكننا من الابتعاد عن سياسات "الحزمة" ، وإنشاء شيء أكثر ملاءمة لاحتياجاتك ...',
    readMore: 'اقرأ أكثر',

    // SectionGetInsurance //
    HeadingSectionGetInsurance: 'احصل على تأمين اليخت',
    quotesInYourEmailNow: 'اقتباسات في بريدك الإلكتروني الآن',
    thousandsOfCustomers:
      'يثق آلاف العملاء في InsuranceMarket.ae للحصول على أفضل صفقات التأمين',
    weWillEmailYourCustom:
      'سنرسل جدول المقارنة المخصص عبر البريد الإلكتروني لتوفير الوقت والمال',
  },
};
